/**
 * VAT helpers for order items.
 *
 * Products store vat_rate as DECIMAL(5,2), nullable:
 *   -1    => VAT exempt (the "VAT Exempt" option in Product Management)
 *    0    => 0%
 *   10    => 10%
 *   null  => never set, treated as exempt
 *
 * Sequelize returns DECIMAL columns as strings ("10.00"), so every value is
 * normalised through parseFloat before it is used or displayed.
 */

/**
 * Read the VAT rate off a product returned by api/admin/products/search
 * (or the quick-create modal) so it can be snapshotted onto a new order item.
 * Returns null when the product carries no usable rate.
 */
export const getProductVatRate = (product) => {
	const rate = product?.vat_rate ?? product?.vatRate;

	if (rate === null || rate === undefined || rate === '') return null;

	const parsed = parseFloat(rate);
	return Number.isNaN(parsed) ? null : parsed;
};

/**
 * True when an item has no VAT applied (no rate stored, or the -1 exempt marker).
 * A rate of 0 is a real 0% rate, not an exemption.
 */
export const isVatExempt = (vatRate) => {
	const parsed = getProductVatRate({vat_rate: vatRate});
	return parsed === null || parsed < 0;
};

/**
 * Label for the "Vat Rate" column: "VAT Exempt", "0%", "10%", "7.5%".
 */
export const formatVatRate = (vatRate) => {
	if (isVatExempt(vatRate)) return 'VAT Exempt';
	return `${parseFloat(vatRate)}%`;
};
